module.exports = __webpack_public_path__ + "static/media/splash-bg-big.ae598e12.jpg";